const publicUrl = process.env.PUBLIC_URL;

export const TESTIMONIALS = [
  {
    id: "razeen-ali",
    name: "Razeen Ali",
    designation: "United States",
    image: `${publicUrl}/testimonials/razeen-ali.png`,
    quote:
      "BestechVision built our website perfectly. It is my second time working with them, and they always deliver. Highly recommended!",
  },
  {
    id: "ahmad-niaz",
    name: "Ahmad Niaz",
    designation: "CEO, Brick Consulting",
    image: `${publicUrl}/testimonials/ahmad-niaz.png`,
    quote:
      "BestechVision demonstrated exceptional attention to detail, delivering a bug-free solution with remarkable efficiency. Their quick responsiveness made the entire process seamless.",
  },
  {
    id: "muhammad-shafaqat",
    name: "Muhammad Shafaqat",
    designation: "CEO, Brick Consulting",
    image: `${publicUrl}/testimonials/muhammad-shafaqat.png`,
    quote:
      "Highly recommended! They did an excellent job and delivered the task as described way before the deadline. Very professional and always communicating.",
  },
  {
    id: "weblytic",
    name: "Weblytic Team",
    designation: "Pakistan",
    image: `${publicUrl}/testimonials/weblytic.png`,
    quote:
      "We provided a Figma design that was flawlessly converted into responsive code. Their professionalism and ability to bring the design to life exceeded our expectations.",
  },
  {
    id: "sarah-k",
    name: "Sarah Khan",
    designation: "Product Manager",
    image: `${publicUrl}/testimonials/sarah-k.png`,
    quote:
      "From planning to launch, BestechVision handled our web application with complete technical competency. The team was friendly, responsive, and delivered on time.",
  },
  {
    id: "james-m",
    name: "James Mitchell",
    designation: "E-commerce Founder",
    image: `${publicUrl}/testimonials/james-m.png`,
    quote:
      "Our e-commerce platform was delivered with excellent quality and ongoing support. BestechVision helped us scale faster with a secure, user-friendly storefront.",
  },
];
